import { render, staticRenderFns } from "./laswxcb.vue?vue&type=template&id=384396d2&scoped=true"
import script from "./laswxcb.vue?vue&type=script&lang=js"
export * from "./laswxcb.vue?vue&type=script&lang=js"
import style0 from "./laswxcb.vue?vue&type=style&index=0&id=384396d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384396d2",
  null
  
)

export default component.exports